import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "../../components";
import { useAppContext } from "../../context/state";
import { useRequest } from "../../utils";
import { useHistory } from "react-router-dom";
import utils from "../../components/toastify/toastify";
//locall
// import "./ShowComments.css";

const GetProductFiles = (props) => {
  let history = useHistory();

  const [
    get_product_files_error,
    get_product_files_loading,
    get_product_files_data,
    get_product_files_function,
  ] = useRequest({
    method: "post",
    url: "/get_product_files",
    body: {
      product_id: props.match.params.id,
    },
  });

  const [
    remove_file_error,
    remove_file_loading,
    remove_file_data,
    remove_file_function,
  ] = useRequest({
    method: "post",
    url: "/remove_product_file",
    isFunction: true,
  });

  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">
                جدول های اطلاعاتی
              </h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">جدول اطلاعات</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <button
          onClick={() =>
            history.push("/dashboard/addFile/" + props.match.params.id)
          }
          style={{ marginTop: "1rem", marginRight: "12px" }}
          type="button"
          class="btn btn-success mr-1 mb-1 "
        >
          افزودن فایل جدید
        </button>
        {/* <div class="row">
          <div class="col-12">
            <p>
              مستندات کامل را بخوانید در
              <a href="https://datatables.net/" target="_blank">
                اینجا
              </a>
            </p>
          </div>
        </div> */}
        {get_product_files_data ? (
          <Table
            Thead={() => (
              <tr>
                <th className="table--title">نام فایل</th>
                {/* <th className="table--title">نام محصول</th>
                <th className="table--title">متن نظر</th>
                <th className="table--title">امتیاز</th>
                <th className="table--title">عملیات</th> */}
                <th className="table--title">عملیات</th>
              </tr>
            )}
            Tbody={() =>
              get_product_files_data.data.map((item) => (
                <tr>
                  <td>{item.title}</td>
                  <td>
                    {/* <Link
                      to={
                        "/dashboard/days/" +
                        item._id +
                        "/terms/" +
                        props.match.params.id
                      }
                    >
                      <button
                        type="button"
                        class="btn btn-primary round mr-1 mb-1 btn-sm"
                      >
                        روز ها
                      </button>
                    </Link> */}
                    <button
                      onClick={() => {
                        remove_file_function({
                          product_id: props.match.params.id,
                          file_id: item._id,
                        })
                          .then(() => {
                            utils.showAlert(
                              "فایل با موفقیت حذف شد.",
                              "success"
                            );
                            get_product_files_function().then(() => null);
                            window.open(
                              "/dashboard/files/" + props.match.params.id,
                              "_self"
                            );
                          })
                          .catch(() =>
                            utils.showAlert("خطایی به وجود آمد", "error")
                          );
                      }}
                      type="button"
                      class="btn btn-danger round mr-1 mb-1 btn-sm"
                    >
                      حذف
                    </button>
                  </td>
                </tr>
              ))
            }
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { GetProductFiles };
